export const DEMO_EMPLOYEE_SOURCE = 'demo-screenshot';

export const DEMO_EMPLOYEE_COUNT_OPTIONS = [6, 12, 18, 24];

export const demoEmployeeIdsStorageKey = (companyId) =>
  `neatschedule:demo-employee-ids:${companyId}`;

/** Same gate as demo appointments — `users/{uid}.isSpecialAdmin`. */
export const isDemoEmployeesToolsEnabled = (isSpecialAdmin) => Boolean(isSpecialAdmin);
